import "assets/scss/pulse.scss";
import { PulseSettings } from "components/Pulse/tabs/settings";
import { PulseWeeklyReport } from "components/Pulse/tabs/weeklyReport";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { getWeekDates, setTab } from "redux/pulse/navigationSlice";
import { setFilters } from "redux/scraperOperations/operationsSlice";
import { fetchScraperOperations } from "redux/scraperOperations/operationsSlice";
import { clearFilters } from "redux/scraperOperations/operationsSlice";

export const PulseMainView = () => {
    const dispatch = useDispatch();

    const { currentTab, selectedWeek, selectedYear } = useSelector((state) => state.pulseNavigation);
    const { loading, error, filters, operations } = useSelector((state) => state.scraperOperations);
    const [runningToast, setRunningToast] = useState(null);

    const tabs = [
        { name: "pulse", icon: <i className="nc-icon nc-chart-bar-32"></i>, component: <></> },
        { name: "settings", icon: <i className="nc-icon nc-settings-gear-64"></i>, component: PulseSettings },
    ];

    useEffect(() => {
        dispatch(getWeekDates({ year: selectedYear, week: selectedWeek }));
    }, [selectedWeek, selectedYear, dispatch]);

    useEffect(() => {
        const newFilters = { name__icontains: "Pulse Scraper", completed: "False" };
        dispatch(setFilters(newFilters));
        dispatch(fetchScraperOperations(newFilters));
    }, []);


    useEffect(() => {
        if (operations && operations?.length > 0) {
            const toastId = operations[0].id;
            if (!(runningToast === toastId)) {
                setRunningToast(toastId);
                toast.loading(`${operations[0].name} running...`, { id: toastId });
            }
            setTimeout(() => {
                dispatch(fetchScraperOperations(filters));
            }, 2000);
        }
        else if (runningToast) {
            toast.dismiss();
            setRunningToast(null);
        }
    }, [operations]);

    return (
        <>
            <div className="main-container m-view">
                {/* <div className="pulse-sidebar">
                    {tabs.map((tab, index) => (
                        <button
                            key={index}
                            className={`pulse-tab ${currentTab === tab.name.toLowerCase() ? 'active' : ''}`}
                            onClick={() => dispatch(setTab(tab.name.toLowerCase()))}
                            title={tab.name.charAt(0).toUpperCase() + tab.name.slice(1)}
                        >
                            {tab.icon}
                            <span className="ml-2 mr-1">{tab.name}</span>
                        </button>
                    ))}
                </div> */}
                {/* <div className="pulse-content"> */}
                {
                    currentTab === "pulse" ? (
                        <div className="pulse-main">
                            <PulseWeeklyReport />
                        </div>
                    ) : currentTab === "settings" ? (
                        <PulseSettings />
                    ) : (
                        <div className="pulse-error">
                            <h3>Error: Invalid Tab</h3>
                        </div>
                    )
                }
                {/* </div> */}
            </div>
            <Toaster position='bottom-right' />
        </>
    )
};